/**
 * @memberof app
 * @ngdoc filter
 * @name areObjectValuesEmpty
 */

(function() {
    'use strict';

    angular.module('app').filter('areObjectValuesEmpty', function() {
        /**
         * @func areObjectValuesEmptyFilter
         * @memberof areObjectValuesEmpty
         * @param {Object} obj
         * @desc returns false if any values in obj are non-null, a non-empty string, or not 0, else returns true (i.e. all values are empty)
         */
        return function (obj) {
            for(var key in obj){
                var val = obj[key];
                if(val !== null && val !== '' && val !== 0){
                    return false;
                }
            }
            return true;
        };
    });

}());